import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { MovementJDVM } from 'src/app/models/requests/MovementJDVM';
import { MovementRequestVM } from 'src/app/models/requests/MovementRequestVM';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { LocationsService } from 'src/app/services/locations.service';
import { MovementService } from 'src/app/services/movement.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-new-movement',
  templateUrl: './new-movement.component.html',
  styleUrls: ['./new-movement.component.css']
})
export class NewMovementComponent implements OnInit {
  @ViewChild('ngNewMovementForm') theForm: any;
  
  // Cache key for localStorage
  private readonly CACHE_KEY = 'movement_form_cache';
  
  currentUser: any;
  Managers:Profile[]=[];
  selectedhrbpId:string="";
  selectedhrrewardandservicesId:string="";

  selectedhrrewardandservices:Profile[]=[];
  HRBPS:Profile[]=[];

  HrRewardAndServices:Profile[]=[];
  FunctionalDirectors:Profile[]=[];
  PlantManagers:Profile[]=[];
  @Input() deleteLink = true;
  @Input() panelTitle = 'Document Uploads';
  @Input() showUploadForm = true;

  @Input() applicationId!: number;
  @Input() referenceNumber = '';

  uploadFileTitle: string = '';
  files!: FileList;
  file!: File;
  fileDocument: any;
  clicked : boolean = false;
  funcdirectorCount : number = 0;
  hrbpCount : number = 0;
  hrCount : number = 0;
  ceoCount : number = 0;
  selectedManagerId:string="";
  selectedfunctionalDirectorId:string="";
  isSelected: boolean = false;
  isShowPlantManager:boolean=false;
  Locations: LocationDto[] | undefined;
  Functions:FunctionDto[]=[];
  Departments: DepartmentDto[] = [];
  CostCenters: CostCenterDto[] | undefined;
  selectedLocationId: string = ''
  promotionDate: Date | null = null;
  DocumentContent: string = '';
  IsPlantManagerToApprove: boolean = false
  dateCurrentRole:Date | null = null;
  effectiveDate:Date | null = null;
  dateVacancyOccured: Date | null = null;
  selectedDepartmentId: string = ''
  selectedrequesterDepartmentId: string = ''
  requestDate: Date | null = null;
  selectedPlantManagerId: string = ''
  selectedProposedDepartmentId: string = ''
  selectedCostCenterId: string = ''
  selectedProposedLocationId: string = ''
  selectedProposedCostCenterId: string = ''
  selectedProposedFunctionId: string = ''
  selectedFunctionId: string = ''
  selectedRequesterFunctionId: string = ''
  employeeName: string = ''
  documentDescription: string = ''
  sapNumber: string = '';
  ProposedNPlusOneDsignation: string = '';
  proposedDesignation: string = '';
  designation: string = '';
  requesterDesignation: string = '';
  justificationForMovement: string = '';
  nPlusOne: string = '';
  Band: string = '';
  developmentPlan: string = '';
  identifiedGaps: string = '';
  comments: string = '';
  
  lastYear: string = '';
  twoYears: string = '';
  threeYears: string = '';
  proposedBand: string = '';
  hrbpToApprove: string ='';
  ohrdToApprove: string = '';
  ceoToApprove:string ='';   
  otherReasonForVacancy: string = '';                    
  typeofmovement:  string = '';
  systemRequirement:  string = '';
  reasonForVacancy: string = '';
  successionPlanReady: string = '';
  modeOfRecruitment: string = '';
  lastTalentReview: string = '';
  talentreview: string = '';
  isreasonForVacancyVisible:boolean=false;
  isreasonForVacancy:boolean=false;
  isShowCEOToApprove:boolean=false;
  requesterName: string = '';

  bands = [
    { name: "A"},
    {  name: "B"},
    {  name: "C"},
    { name: "D"},
    { name: "E"},
    { name: "F"},
    { name: "F PLUS"},
    { name: "G"},
    { name: "H"}
  ];

  Proposedbands = [
    { name: "A"},
    {  name: "B"},
    {  name: "C"},
    { name: "D"},
    { name: "E"},
    { name: "F"},
    { name: "F PLUS"},
    { name: "G"},
    { name: "H"}
  ];

  performanceReview = [
    { performance: "NEW IN THE JOB"},
    {  performance: "INCONSISTENT PERFORMANCE"},
    {  performance: "GOOD PERFORMANCE"},
    { performance: "HIGH PERFORMANCE"},
    { performance: "OUTSTANDING PERFORMANCE"},
    { performance: "N/A"},
  ];

  typeOfMovement: any = {
    TemporaryAssignment : false,
    LateralMove : false,
    Promotion : false,
    Relocation : false,
  };

  systemRequirements: any = {
    bcmix : false,
    labmix : false,
    holdim : false,
    salesforce : false,
    sap : false
  };

  talentReview = [
    { review: "READY THIS YEAR"},
    {  review: "READY IN 1-3 YEARS"},
    {  review: "READY IN 3-6 YEARS"}
  ];

  Reasonforvacancy = [
    { reasonforvacancy: "Resignation"},
    {  reasonforvacancy: "Termination"},
    {  reasonforvacancy: "Dismissal"},
    { reasonforvacancy: "Retirement"},
    { reasonforvacancy: " New Position:"},
  ];

  constructor(
    private locationService: LocationsService,
    private notification: NotificationService,
    private MovementService: MovementService,
    private costCenterService: CostCentersService,
    private department: DepartmentsService,
    private nznotification: NzNotificationService,
    private tokenService: TokenService,
    private userService: UserService,
    private functionService:FunctionsService,
  ) { }

  ngOnInit(): void {
    this.LoadDropDowns();
    // Load cached data after dropdowns are loaded
    setTimeout(() => {
      this.loadCachedData();
    }, 500);
  }

  async LoadDropDowns() {
    if (this.isShowPlantManager == false){
      this.funcdirectorCount = 2
      this.hrbpCount = 3
      this.hrCount = 4
      this.ceoCount = 5
    }

    this.currentUser = this.tokenService.getInfo();
    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;
    
    let resCostCenterss = await this.costCenterService.getCostCenters().toPromise();
    this.CostCenters = <CostCenterDto[]>resCostCenterss.responseData;
    
    let resDeparts = await this.department.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;
    
    let functions = await this.functionService.getAllFunctions().toPromise();
    this.Functions = <FunctionDto[]>functions.responseData;
    
    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;

    let userhrrewardandservices = await this.userService.getHRSharedServices().toPromise();
    this.selectedhrrewardandservices = <Profile[]>userhrrewardandservices.responseData;
    
    let directors = await this.userService.getFunctionalDirectors().toPromise();
    this.FunctionalDirectors = <Profile[]>directors.responseData;
    
    let plantManager = await this.userService.getManagersUsers().toPromise();
    this.PlantManagers = <Profile[]>plantManager.responseData;

    let ohrDirector = await this.userService.getOHRDirector().toPromise();
    let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
    this.ohrdToApprove = ohrDirectorRes[0].email;

    let ceo = await this.userService.getCEO().toPromise();
    let ceoRes = <Profile[]>ceo.responseData;
    this.ceoToApprove = ceoRes[0].email;
  }

  /**
   * Save form data to localStorage
   */
  saveToCache(): void {
    const formData = {
      // Requester Details
      requesterName: this.requesterName,
      requesterDesignation: this.requesterDesignation,
      selectedrequesterDepartmentId: this.selectedrequesterDepartmentId,
      selectedRequesterFunctionId: this.selectedRequesterFunctionId,
      requestDate: this.requestDate,
      
      // Current Employee Data
      employeeName: this.employeeName,
      sapNumber: this.sapNumber,
      Band: this.Band,
      designation: this.designation,
      selectedDepartmentId: this.selectedDepartmentId,
      selectedFunctionId: this.selectedFunctionId,
      nPlusOne: this.nPlusOne,
      selectedLocationId: this.selectedLocationId,
      promotionDate: this.promotionDate,
      dateCurrentRole: this.dateCurrentRole,
      
      // Proposed Employee Data
      proposedDesignation: this.proposedDesignation,
      ProposedNPlusOneDsignation: this.ProposedNPlusOneDsignation,
      selectedProposedDepartmentId: this.selectedProposedDepartmentId,
      selectedProposedFunctionId: this.selectedProposedFunctionId,
      effectiveDate: this.effectiveDate,
      proposedBand: this.proposedBand,
      selectedProposedCostCenterId: this.selectedProposedCostCenterId,
      selectedProposedLocationId: this.selectedProposedLocationId,
      
      // Role Details
      dateVacancyOccured: this.dateVacancyOccured,
      reasonForVacancy: this.reasonForVacancy,
      justificationForMovement: this.justificationForMovement,
      
      // Type of Movements & System Requirements
      typeOfMovement: this.typeOfMovement,
      systemRequirements: this.systemRequirements,
      
      // Succession Plan & Transition
      lastYear: this.lastYear,
      twoYears: this.twoYears,
      threeYears: this.threeYears,
      lastTalentReview: this.lastTalentReview,
      successionPlanReady: this.successionPlanReady,
      developmentPlan: this.developmentPlan,
      identifiedGaps: this.identifiedGaps,
      comments: this.comments,
      
      // Approvals
      selectedManagerId: this.selectedManagerId,
      selectedPlantManagerId: this.selectedPlantManagerId,
      selectedfunctionalDirectorId: this.selectedfunctionalDirectorId,
      selectedhrbpId: this.selectedhrbpId,
      
      // Additional flags
      isShowPlantManager: this.isShowPlantManager,
      isShowCEOToApprove: this.isShowCEOToApprove,
      funcdirectorCount: this.funcdirectorCount,
      hrbpCount: this.hrbpCount,
      hrCount: this.hrCount,
      ceoCount: this.ceoCount,
    };

    try {
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(formData));
    } catch (error) {
      console.error('Error saving to cache:', error);
    }
  }

  /**
   * Load cached data from localStorage
   */
  loadCachedData(): void {
    try {
      const cachedData = localStorage.getItem(this.CACHE_KEY);
      if (cachedData) {
        const formData = JSON.parse(cachedData);
        
        // Requester Details
        this.requesterName = formData.requesterName || '';
        this.requesterDesignation = formData.requesterDesignation || '';
        this.selectedrequesterDepartmentId = formData.selectedrequesterDepartmentId || '';
        this.selectedRequesterFunctionId = formData.selectedRequesterFunctionId || '';
        this.requestDate = formData.requestDate || null;
        
        // Current Employee Data
        this.employeeName = formData.employeeName || '';
        this.sapNumber = formData.sapNumber || '';
        this.Band = formData.Band || '';
        this.designation = formData.designation || '';
        this.selectedDepartmentId = formData.selectedDepartmentId || '';
        this.selectedFunctionId = formData.selectedFunctionId || '';
        this.nPlusOne = formData.nPlusOne || '';
        this.selectedLocationId = formData.selectedLocationId || '';
        this.promotionDate = formData.promotionDate || null;
        this.dateCurrentRole = formData.dateCurrentRole || null;
        
        // Proposed Employee Data
        this.proposedDesignation = formData.proposedDesignation || '';
        this.ProposedNPlusOneDsignation = formData.ProposedNPlusOneDsignation || '';
        this.selectedProposedDepartmentId = formData.selectedProposedDepartmentId || '';
        this.selectedProposedFunctionId = formData.selectedProposedFunctionId || '';
        this.effectiveDate = formData.effectiveDate || null;
        this.proposedBand = formData.proposedBand || '';
        this.selectedProposedCostCenterId = formData.selectedProposedCostCenterId || '';
        this.selectedProposedLocationId = formData.selectedProposedLocationId || '';
        
        // Role Details
        this.dateVacancyOccured = formData.dateVacancyOccured || null;
        this.reasonForVacancy = formData.reasonForVacancy || '';
        this.justificationForMovement = formData.justificationForMovement || '';
       
        
        // Succession Plan & Transition
        this.lastYear = formData.lastYear || '';
        this.twoYears = formData.twoYears || '';
        this.threeYears = formData.threeYears || '';
        this.lastTalentReview = formData.lastTalentReview || '';
        this.successionPlanReady = formData.successionPlanReady || '';
        this.developmentPlan = formData.developmentPlan || '';
        this.identifiedGaps = formData.identifiedGaps || '';
        this.comments = formData.comments || '';
        
        // Approvals
        this.selectedManagerId = formData.selectedManagerId || '';
        this.selectedPlantManagerId = formData.selectedPlantManagerId || '';
        this.selectedfunctionalDirectorId = formData.selectedfunctionalDirectorId || '';
        this.selectedhrbpId = formData.selectedhrbpId || '';
        
        // Additional flags
        this.isShowPlantManager = formData.isShowPlantManager || false;
        this.isShowCEOToApprove = formData.isShowCEOToApprove || false;
        this.funcdirectorCount = formData.funcdirectorCount || 2;
        this.hrbpCount = formData.hrbpCount || 3;
        this.hrCount = formData.hrCount || 4;
        this.ceoCount = formData.ceoCount || 5;
        
        console.log('Form data loaded from cache');
      }
    } catch (error) {
      console.error('Error loading cached data:', error);
    }
  }

  /**
   * Clear cached data from localStorage
   */
  clearCache(): void {
    try {
      localStorage.removeItem(this.CACHE_KEY);
      console.log('Cache cleared');
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }

  onChangeFunctions(event:string) {
    const movementfunction:string=(event);
    let item = this.Departments.find(i => i.name === movementfunction);

    if(item?.name=== "INDUSTRIAL") {
      this.isShowPlantManager=true;
      this.funcdirectorCount = 3
      this.hrbpCount = 4
      this.hrCount = 5
      this.ceoCount = 6
    } else {
      this.isShowPlantManager=false;
      this.funcdirectorCount = 2
      this.hrbpCount = 3
      this.hrCount = 4
      this.ceoCount = 5
    }
    
    // Save to cache after change
    this.saveToCache();
  }

  onFileChange(event : any) {
    this.files = event.target.files;
    this.file = this.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = () => {
      this.DocumentContent = reader.result as string
    };
  }

  onSubmit(): void {
    this.clicked = true;
    
    let req : string[] = [];
    let selectedReqVal = Object.values(this.typeOfMovement),
    selectedReqKeys = Object.keys(this.typeOfMovement);

    selectedReqVal.forEach((x:any,i:number) => {
      if(x) req.push(selectedReqKeys[i])
    })
    let typeofmovements = req.join(',');
    
    if(this.selectedPlantManagerId != ''){
      this.IsPlantManagerToApprove = true
    }
    
    let req1 : string[] = [];
    let selectedReqVal1 = Object.values(this.systemRequirements),
    selectedReqKeys1 = Object.keys(this.systemRequirements);

    selectedReqVal1.forEach((x:any,i:number) => {
      if(x) req1.push(selectedReqKeys1[i])
    })
    let systemRequirements = req1.join(',');

    let additionalDocument: MovementJDVM | undefined;
    if (this.file) {
      additionalDocument = {
        RequestId: 0,
        DocumentName: this.file.name,
        DocumentContent: this.DocumentContent,
        ContentType: (this.MovementService.fileExtention(this.file.name)).toLowerCase(),
        DocumentDescription: this.documentDescription,
      };
    }
    
    let ManpowerRequestVM: MovementRequestVM = {
      EmployeeName: this.employeeName,
      EmployeeBand: this.Band,
      RequesterName: this.requesterName,
      RequesterDesignation: this.requesterDesignation,
      RequesterFunction: this.selectedrequesterDepartmentId,
      RequesterUnit: this.selectedRequesterFunctionId,
      RequestDate: this.requestDate,
      AdditionalDocument:additionalDocument,
      EmployeeSAPNumber: this.sapNumber,
      EmployeeDesignation: this.designation,
      EmployeeUnit: this.selectedFunctionId,
      EmployeeNPlus1: this.nPlusOne,
      EmployeeCurrentLocation: this.selectedLocationId,
      DatAssumeCurrentRole: this.dateCurrentRole,
      LastPromotionDate: this.promotionDate,
      ProposedDesignation: this.proposedDesignation,
      ProposedNPlus1: this.ProposedNPlusOneDsignation,
      ProposedFunction: this.selectedProposedDepartmentId,
      ProposedBand: this.proposedBand,
      ProposedUnit: this.selectedProposedFunctionId,
      ProposedCostCenter: this.selectedProposedCostCenterId,
      ProposedLocation: this.selectedProposedLocationId,
      EffectiveDate: this.effectiveDate,
      DateVacancyOccured: this.dateVacancyOccured,
      ReasonForVacancy: this.reasonForVacancy,
      JustificationForVacancy: this.justificationForMovement,
      TypeOfMovement: typeofmovements,
      SystemRequirementForNewRole: systemRequirements,
      PerformanceLastYear: this.lastYear,
      TwoYearsPerformance: this.twoYears,
      ThreeYearsPerformance: this.threeYears,
      LastTalentReviewComment: this.lastTalentReview,
      SuccessionPlanReady  : this.successionPlanReady,
      DevelopmentPlan: this.developmentPlan,
      IdentifiedGaps: this.identifiedGaps,
      UnitHeadToApprove: this.selectedManagerId,
      HRBPToApprove: this.selectedhrbpId,
      HRRewardAndSharedServicesToApprove: this.selectedhrrewardandservicesId,
      FunctionDirectorToApprove: this.selectedfunctionalDirectorId,
      RequesterComment: this.comments,
      IsPlantManagerToApprove:this.IsPlantManagerToApprove,
      PlantManagerToApprove:this.selectedPlantManagerId,
      OHRDToApprove: this.ohrdToApprove,
      CEOToApprove: this.ceoToApprove,
    };

    this.MovementService.saveMovement(ManpowerRequestVM).subscribe({
      next: (data => {
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Movement Request created successfully.`,
            type: NotificationType.success
          });
        
          // Clear cache on successful submission
          this.clearCache();
          
          this.theForm.resetForm();
          this.clicked = false;
        } else {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.clicked = false;
        }
      }),
      error: ((error: any) => {
        console.log(error.error);
        
        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.clicked = false;
      })
    });
  }

  onChangeBand(event:string) {
    const band:string=(event);
    if(event ==""){ 
      this.isreasonForVacancyVisible=false;
      this.isreasonForVacancy=false;
    }
    let item = this.Proposedbands.find(i => i.name === band);

    if(item?.name=== "A" || item?.name=== "B" || item?.name=== "C" || 
       item?.name=== "D"  || item?.name=== "E" ) {
      this.isShowCEOToApprove=true;
    } else {
      this.isShowCEOToApprove=false;
    }
    
    // Save to cache after change
    this.saveToCache();
  }
}